export const SHOW_LOADING = 'view/SHOW_LOADING'


export const ShowLoading = (loading) => {
  return {type: SHOW_LOADING, loading: loading}
}
